import React from 'react'
import AboutIcon from '../../assets/img/logo/favicon.png';
import { Link } from 'react-router-dom';
import empowerImg from '../../assets/img/empower.png';
import Shape from '../../assets/img/shape-2.png';
import CardImg from '../../assets/img/business.png';
import icon1 from '../../assets/img/solar_qr-code.png';
import icon2 from '../../assets/img/basil_invoice-outline.png';
import { Helmet } from "react-helmet-async";

function BusinessAccount() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Business Account - Cardplot</title>
                <meta name="description" content="Cardplot's Business Account is tailored to meet the specific needs of African businesses, recognizing the continent's rich cultural diversity and economic landscape." />
            </Helmet>
            <section className='breadcrumb__section__02 padding__tb__100'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="breadcrumb__title__head">
                                <ol className="breadcrumb">
                                    <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                                </ol>
                                <h2 className='breadcrumb__title'> FEATURES </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'>Business Accounts</h3>
                                <p className='breadcrumb__text__content '>
                                    Cardplot’s Business Account is tailored to meet the specific needs of African businesses, recognizing the continent's rich cultural diversity and economic landscape. <br />
                                    With Cardplot, managing your business finances is no longer a burden—it’s a gateway to growth. We’re redefining financial services to create a more inclusive, accessible, and empowered African business ecosystem.
                                </p>
                            </div>
                            <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                                <Link to='/contact' className='btn btn__outline_primary '>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='virtual__section payment__link__section padding__tb__100'>
                <div className='container'>
                    <div className='row justify-content-around align-items-center' >
                        <div className='col-12 col-md-7 mb-4 mb-lg-0 '>
                            <div className='virtual__section__content'>
                                <h3>
                                    Stress-Free Business Financial Management
                                </h3>
                                <p>
                                    We’re redefining financial services to create a more inclusive, accessible, and empowered African business ecosystem.
                                </p>
                                <a className='btn btn__primary mt-4' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 mb-4 mb-lg-0 '>
                            <div className='payment__link__section__image d-flex justify-content-end align-items-center'>
                                <img src={CardImg} className='img-fluid' alt='virtual cards' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='create__virtual__card__section business__section padding__tb__50'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='position-relative'>
                                <h2 className='create__virtual__card__section__title'>Business Account Benefits:</h2>
                            </div>
                        </div>
                    </div>
                    <div className='bill__payment__section__content padding__tb__50'>
                        <div className="row">
                            <div className='bill__payment__section__content__item'>
                                <img src={icon1} className='img-fluid' alt="" />
                                <div className='bill__payment__section__content__left bill__payment__section__content__content'>
                                    <h4>Payment Links: </h4>
                                    <p>
                                        Create and share secure payment links with ease to receive payments from customers. Simplify transactions without the need for complicated setups or integrations.
                                    </p>
                                </div>
                            </div>
                            <div className='bill__payment__section__content__item'>
                                <img src={icon2} className='img-fluid' alt="" />
                                <div className='bill__payment__section__content__left bill__payment__section__content__content'>
                                    <h4>Invoice:</h4>
                                    <p>
                                        Generate detailed, professional invoices in seconds and send them directly to your customers. Track payments effortlessly and maintain organized financial records.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='create__virtual__card__section padding__tb__50'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='position-relative'>
                                <h2 className='create__virtual__card__section__title'>Why choose Cardplot’s Business Account?:</h2>
                            </div>
                        </div>
                    </div>
                    <div className='create__virtual__account__section__content'>
                        <div className='create__virtual__account__section__content_right'>
                            <div className='create__virtual__card__section__content__item'>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        1
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Tailored for African Markets</h4>
                                        <p>Our accounts are designed with Africa’s unique business landscape in mind, accommodating local currencies and cross-border trade needs.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        2
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Simplified Financial Management</h4>
                                        <p>Monitor your transactions, generate reports, and manage expenses effortlessly with our user-friendly dashboard.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        3
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Seamless Cross-border payments</h4>
                                        <p>As a Pan-African solution, Cardplot enables businesses to send and receive payments across borders with minimal fees and maximum efficiency</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        4
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Secure and Reliable</h4>
                                        <p>Your business data and funds are protected with top-tier encryption and multi-layered security protocols.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='empower_your_trade overlay'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__title">
                                <h2>Ready to simplify your payments?</h2>
                                <p>Simplify Your Exchange, Empower Your Trade</p>
                                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                                    <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                        Get Started
                                    </a>
                                    <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__img">
                                <img src={empowerImg} className='img-fluid' alt="empower" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BusinessAccount